import React from "react";
import { Bounce, ToastContainer, toast, type IconProps, type ToastContent, type ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./or-toast.css";
import { OR_TOAST_DEFAULT_OPTIONS } from "./or-toast.hook";

export interface OrToastContainerProps {
  limit?: number;
}

function renderOrToastIcon({ type }: IconProps): React.ReactElement {
  switch (type) {
    case "success":
      return (
        <svg className="or-toast__icon or-toast__icon--success" viewBox="0 0 24 24" aria-hidden="true">
          <path className="or-toast__icon-stroke" d="M4.75 12.35 9.5 17.1 19.25 6.9" />
        </svg>
      );
    case "warning":
      return (
        <svg className="or-toast__icon or-toast__icon--warning" viewBox="0 0 24 24" aria-hidden="true">
          <path className="or-toast__icon-fill" d="M11.06 2.62a1.08 1.08 0 0 1 1.88 0l10.1 17.5a1.08 1.08 0 0 1-.94 1.62H1.9a1.08 1.08 0 0 1-.94-1.62l10.1-17.5Z" />
          <path className="or-toast__icon-mark" d="M11 8.2h2v6.7h-2V8.2Zm0 8.5h2v2h-2v-2Z" />
        </svg>
      );
    case "error":
      return (
        <svg className="or-toast__icon or-toast__icon--error" viewBox="0 0 24 24" aria-hidden="true">
          <path className="or-toast__icon-stroke" d="M5.5 5.5 18.5 18.5M18.5 5.5 5.5 18.5" />
        </svg>
      );
    case "default":
    case "info":
      return (
        <svg className="or-toast__icon or-toast__icon--info" viewBox="0 0 24 24" aria-hidden="true">
          <circle className="or-toast__icon-fill" cx="12" cy="12" r="11" />
          <path className="or-toast__icon-mark" d="M11 10h2v7h-2v-7Zm0-3h2v2h-2V7Z" />
        </svg>
      );
  }
}

export function OrToastContainer({ limit = 3 }: OrToastContainerProps): React.ReactElement {
  return (
    <ToastContainer
      autoClose={OR_TOAST_DEFAULT_OPTIONS.autoClose}
      bodyClassName="or-toast__body"
      className="or-toast-container"
      closeButton={false}
      closeOnClick={OR_TOAST_DEFAULT_OPTIONS.closeOnClick}
      draggable
      draggableDirection="x"
      draggablePercent={80}
      hideProgressBar={OR_TOAST_DEFAULT_OPTIONS.hideProgressBar}
      icon={renderOrToastIcon}
      limit={limit}
      newestOnTop
      pauseOnFocusLoss
      pauseOnHover
      position={OR_TOAST_DEFAULT_OPTIONS.position}
      progressClassName="or-toast__progress"
      role="alert"
      theme={OR_TOAST_DEFAULT_OPTIONS.theme}
      toastClassName="or-toast"
      transition={Bounce}
    />
  );
}

export function showOrToast(message: ToastContent, options?: ToastOptions): void {
  toast(message, {
    ...OR_TOAST_DEFAULT_OPTIONS,
    icon: renderOrToastIcon,
    ...options,
  });
}
